/**
 * sequences operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import {fetchJSON} from "./communication";
import {
    REST_CALL_GET_NEXT_SEQUENCE_VALUE,
    REST_SERVER_BASE_URL
} from "../config";


export async function requestNextSequenceValues(fieldDefs, accessToken) {

    let result = {};
    for (const fieldDef of fieldDefs) {
        try {
            result[fieldDef.id] = await requestNextSequenceValue(fieldDef, accessToken);
        }
        catch (error) {
            console.log("error requesting sequence values", error);
        }
    }
    return result;
}


export async function requestNextSequenceValue(fieldDef, accessToken) {

    const sequenceId = fieldDef.sequence;
    const value = await fetchNextSequenceValue(sequenceId, accessToken);
    const number = String(value).padStart(fieldDef.digits || 0, '0');
    const prefix = fieldDef.prefix || "";
    return prefix + number;
}


export async function fetchNextSequenceValue(sequenceId, accessToken) {

    const response = await fetchJSON(
        REST_SERVER_BASE_URL + REST_CALL_GET_NEXT_SEQUENCE_VALUE.path.replace("<id>", sequenceId), {
            method: REST_CALL_GET_NEXT_SEQUENCE_VALUE.method,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + accessToken
            }
        }
    );
    return response.value;
}
